import { FC, useMemo } from "react"
import { Button, ButtonProps, useTheme } from "@mui/material"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"
import { HomeIcon } from "components/icons"

interface IHomeButtonProps extends ButtonProps {
  label?: string
}

export const HomeButton: FC<IHomeButtonProps> = ({
  label = "Home",
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const homeIcon = useMemo(
    () => getIcon(theme?.assets?.navigation?.home) || <HomeIcon />,
    [theme]
  )

  return (
    <Button variant="contained" startIcon={homeIcon} {...props}>
      {t(label)}
    </Button>
  )
}
